import { DateTime } from 'luxon'
import React, { memo, useMemo } from 'react'

import { MEETING_STATUS_ORDER, MEETING_STATUS_TO_COLOR_MAP, VISIBLE_DAYS_AMOUNT } from '@modules/contacts/constants'
import { MeetingOverview } from '@modules/contacts/types'
import Box from '@mui/material/Box'
import { createMapFromArr } from '@shared/utils'

import { DayWrapper } from './index.styles'
import { isoDateEquals } from './utils'

interface DaysViewProps {
  month: number
  day: number
  year: number
  meetings: MeetingOverview[]
  selectedDay?: string
  onDayClick: (dayIso: string) => void
}

const DaysView = ({ year, month, day, meetings, selectedDay, onDayClick }: DaysViewProps) => {
  const meetingsByDate = useMemo(
    () => createMapFromArr<MeetingOverview>(meetings, m => DateTime.fromISO(m.date).toUTC().toISODate() as string),
    [meetings],
  )

  const dateRange = useMemo(
    () =>
      Array.from({ length: VISIBLE_DAYS_AMOUNT }, (_, i) => {
        const date = DateTime.local().set({ month, day, year }).plus({ days: i })
        const isoDate = date.toISO() as string
        const dateMeetings = meetingsByDate[date.toUTC().toISODate() as string]

        const foundStatus = MEETING_STATUS_ORDER.find(statusKey => dateMeetings?.some(m => m.status === statusKey))

        return { label: date.toFormat('dd'), status: foundStatus, iso: isoDate }
      }),
    [meetingsByDate, day],
  )

  return (
    <Box display="flex" justifyContent="space-between" width="100%" height="27px" alignItems="center">
      {dateRange.map(i => (
        <DayWrapper
          key={i.label}
          $color={MEETING_STATUS_TO_COLOR_MAP[i.status!]?.bar ?? ''}
          $selected={!!selectedDay && isoDateEquals(i.iso, selectedDay)}
          onClick={() => onDayClick?.(i.iso || '')}
        >
          {i.label}
        </DayWrapper>
      ))}
    </Box>
  )
}

export default memo(DaysView)
